export const INVENTORY_DISPLAY_MODE = {
	WITH_ACTIVE_INVENTORY: "WITH_ACTIVE_INVENTORY",
	WITH_INVENTORY: "WITH_INVENTORY",
	ALL: "ALL",
} as const;

export type InventoryDisplayMode =
	(typeof INVENTORY_DISPLAY_MODE)[keyof typeof INVENTORY_DISPLAY_MODE];

export const DEFAULT_INVENTORY_DISPLAY_MODE: InventoryDisplayMode =
	INVENTORY_DISPLAY_MODE.WITH_ACTIVE_INVENTORY;

const INVENTORY_DISPLAY_MODE_VALUES = new Set<string>(Object.values(INVENTORY_DISPLAY_MODE));

export const parseInventoryDisplayMode = (
	value: string | null | undefined,
): InventoryDisplayMode => {
	if (value && INVENTORY_DISPLAY_MODE_VALUES.has(value)) {
		return value as InventoryDisplayMode;
	}

	return DEFAULT_INVENTORY_DISPLAY_MODE;
};

export const getInventoryDisplayModeFromSearchParams = (
	params: URLSearchParams,
): InventoryDisplayMode => {
	const inventoryDisplayMode = params.get("inventoryDisplayMode");

	if (inventoryDisplayMode) {
		return parseInventoryDisplayMode(inventoryDisplayMode);
	}

	// Legacy fallback while old links using includeNotPo still exist.
	if (params.get("includeNotPo") === "true") {
		return INVENTORY_DISPLAY_MODE.ALL;
	}

	return DEFAULT_INVENTORY_DISPLAY_MODE;
};
